import api from "./api";

export const reportingService = {
  getGrossProfit(startDate, endDate) {
    return api.get("/reports/gross-profit", { params: { startDate, endDate } });
  },
  getCashFlow(startDate, endDate) {
    return api.get("/reports/cash-flow", { params: { startDate, endDate } });
  },
  getTopProducts(limit, startDate, endDate) {
    return api.get("/reports/top-products", { params: { limit, startDate, endDate } });
  }
};
